import React, { useState } from 'react';
import { StytchHeadlessClient } from '@stytch/vanilla-js/headless';
import { APP_URL } from '../config';

console.log('REACT_APP_STYTCH_PUBLIC_TOKEN', process.env.REACT_APP_STYTCH_PUBLIC_TOKEN);
const stytch = new StytchHeadlessClient(process.env.REACT_APP_STYTCH_PUBLIC_TOKEN);

/*
Login configures and renders the StytchLogin component which is a prebuilt UI component for auth powered by Stytch

This component accepts style, config, and callbacks props. To learn more about possible options review the documentation at
https://stytch.com/docs/sdks/javascript-sdk#ui-configs
*/

const Login = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const onHandleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      await stytch.magicLinks.email.loginOrCreate(email, {
        login_magic_link_url: APP_URL,
        signup_magic_link_url: APP_URL,
        login_expiration_minutes: 10080,
        signup_expiration_minutes: 10080,
      });
      setSuccess(true);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleOAuth = async () => {
    try {
      // Initiate the Google OAuth flow
      await stytch.oauth.google.start({
        login_redirect_url: APP_URL,
        signup_redirect_url: APP_URL,
        login_expiration_minutes: 10080,
        signup_expiration_minutes: 10080,
      });
    } catch (error) {
      console.error("Error during Google OAuth:", error);
      setError('Google OAuth login failed. Please try again.');
    }
  };

  return (
    <div className="max-w-xl md:max-w-2xl lg:max-w-3xl mx-auto">
      {!success && (
        <div className="flex flex-col gap-4">
          <form className="flex flex-col md:flex-row gap-4">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-grow p-2 border rounded"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button
              onClick={onHandleLogin}
              className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600 whitespace-nowrap"
            >
              {isLoading ? 'Loading...' : 'Create account or login'}
            </button>
          </form>

          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-white text-gray-500">Or</span>
            </div>
          </div>

          <button
            onClick={handleGoogleOAuth}
            className="flex items-center justify-center gap-2 bg-white text-gray-700 border border-gray-300 px-6 py-2 rounded hover:bg-gray-50"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.24 10.285V14.4h6.806c-.275 1.765-2.056 5.174-6.806 5.174-4.095 0-7.439-3.389-7.439-7.574s3.345-7.574 7.439-7.574c2.33 0 3.891.989 4.785 1.849l3.254-3.138C18.189 1.186 15.479 0 12.24 0c-6.635 0-12 5.365-12 12s5.365 12 12 12c6.926 0 11.52-4.869 11.52-11.726 0-.788-.085-1.39-.189-1.989H12.24z" fill="#4285F4"/>
            </svg>
            Login with Google
          </button>

          {error && <p className="text-red-500">{error}</p>}
        </div>
      )}
      {success && <p className="text-green-500">Check your inbox for the magic link ;)</p>}
    </div>
  );
};

export default Login;
